<!--
 * @Description: 受理进度
--> 
<template>
  <div class="online-progress">
    <div class="tab-content">
      <div class="comm-search-bar2">
        <div class="bar-con">
          <!-- <van-field style="width:49%;" v-model="userno" label="用户号" placeholder="" /> -->
          <van-field style="width:98%;" v-model="bussno" label="查询内容" placeholder="受理编号/手机号码" />
          <!-- <van-field style="width:49%;" v-model="phone" label="手机号码" placeholder="手机号码" /> -->
        </div>
        <div class="bar-btn" @click="getProgressData()">
          查询
        </div>
      </div>
      <div class="comm-seperator"></div>
      <div class="progress-info" v-for="(progress, i) in progressList" :key="i">
        <div class="info-top-wrapper">
          <div class="info-top">
            <div class="info-name">业务类型：</div>
            <div class="info-value">{{progress.busstype}}</div>
          </div>
          <div class="info-top">
            <div class="info-name">受理编号：</div>
            <div class="info-value">{{progress.bussno}}</div>
          </div>
          <div class="info-top">
            <div class="info-name">提交时间：</div>
            <div class="info-value">{{progress.adddate}}</div>
          </div>
          <div class="info-top">
            <div class="info-name">状态：</div>
            <div class="info-value">
              <van-button plain round size="small" type="default" 
                color="#FF0000"
                style="width:63px;height:20px;"
                >
                {{progress.status}}
              </van-button>
            </div>
          </div>
          <div class="info-top">
            <div class="info-name">办理进度：</div>
            <div class="info-value">
              <van-steps :active="progress.active">
                <van-step v-for="(process, p) in progress.processlist" :key="p">
                  {{process.stepname}}
                </van-step>
              </van-steps>
            </div>
          </div>
        </div>
        <div v-show="false" class="info-bottom-wrapper">
          <div class="bottom-title">
            未缴费清单（<span style="color:#2C82C9">2笔</span>）
          </div>
          <div class="bottom-info">
            <div class="bottom-name">工程基准费：</div>
            <div class="bottom-value">
              <span style="color:#FF0000">1300.00</span>&nbsp;元</div>
          </div>
          <div class="bottom-info">
            <div class="bottom-name">工程材料费：</div>
            <div class="bottom-value">
              <span style="color:#FF0000">300.00</span>&nbsp;元
            </div>
          </div>
        </div>
        <div v-show="false" class="code">
          <div class="code-img">
            <img>
          </div>
          <div class="code-txt">微信、支付宝扫码缴费</div>
        </div>
      </div>
      <div style="height:17px;"></div>
      <div v-if="!progressList||progressList.length===0" style="text-align:center;">
        <img
          style="width:200px;"
          :src="require('../../assets/images/no-data.png')"
          >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OnlineProgress',
  components: {
  },
  data() {
    return {
      active: 0,
      typeList: [],
      typeCode: '',
      typeName: '',
      progressList: [],
      columns: [],
      showPicker: false,
      userno: '',
      bussno: ''
    }
  },
  mounted() {
    if (this.$route.query.active) {
      this.active = Number(this.$route.query.active)
    }
  },
  beforeRouteLeave (to, from, next) {
    to.meta.isUseCache = true
    next()
  },
  methods: {
    getProgressData () {
      if(this.bussno===''){
        this.$toast('请输入查询内容');
        return;
      }
      this.$loading()
      this.$http.post(this.$api.businessProgress, {
        souid: 0, // 业务来源：0-非网厅 1-网厅
        userno: this.userno, // 用户号
        bussno: this.bussno, // 受理编号/手机号码
      }).then(res => {
        this.$clear()
        if (res.code === '000') {
          this.progressList = res.data
          if(this.progressList&&this.progressList.length>0){
            for(let progress of this.progressList){
              progress['active'] = null
              for(let i=0;i<progress.processlist.length;i++){
                if(progress.processlist[i].status===1){
                  progress['active'] = i
                }
              }
            }
          }
        } else {
          this.$toast(res.msg)
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.online-progress{
  background:#FFFFFF;
  .tab-content{
    .progress-info{
      padding: 0 16px;
      margin-top: 17px;
      .info-top-wrapper{
        background:rgba(240,246,241,1);
        border-radius:3px;
        border:1px solid rgba(214,216,214,1);
        padding: 10px 12px;
        .info-top{
          display: flex;
          font-size:14px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(33,33,33,1);
          .info-name{
            width: 70px;
          }
          .info-value{
            width: calc(~"100% - 70px");
          }
        }
      }
      .info-bottom-wrapper{
        margin-top: 14px;
        background:rgba(240,246,241,1);
        border-radius:3px;
        .bottom-title{
          height:26px;
          line-height: 26px;
          padding: 0 16px;
          background:rgba(240,246,241,1);
          border:1px solid rgba(214,216,214,1);
          font-size:12px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(33,33,33,1);;
        }
        .bottom-info{
          display: flex;
          align-items: center;
          padding: 0 16px;
          font-size:14px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(33,33,33,1);
          height: 35px;
          background: #ffffff;
          border-bottom:1px solid rgba(214,216,214,1);
          border-left:1px solid rgba(214,216,214,1);
          border-right:1px solid rgba(214,216,214,1);
          .bottom-name{
            width: 84px;
          }
          .bottom-value{
            width: calc(~"100% - 84px");
            text-align: right;
          }
        }
      }
      .code{
        margin-top: 30px;
        text-align: center;
        .code-img{
          img{
            width: 168px;
            height: 168px;
          }
        }
        .code-txt{
          font-size:12px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(117,117,117,1);
        }
      }
    }
  }
}
</style>